"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fieldset = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./Fieldset.pc.css");
const Fieldset = ({ className, squished, label, children, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_e78f3d', '_e94058f2', '_pub-e94058f2', '_pub-3c25d522', '_e94058f2_compact', '_pub-e94058f2_compact', '_pub-3c25d522_compact', 'compact', {
            '_e94058f2_squished _pub-e94058f2_squished _pub-3c25d522_squished squished': squished,
        }, className), "data-pc-label": "Fieldset" },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_27c29ec2', '_e94058f2', '_pub-e94058f2', '_pub-3c25d522', '_e94058f2_text-heading-small', '_pub-e94058f2_text-heading-small', '_pub-3c25d522_text-heading-small', 'text-heading-small') }, label),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_becbcf78', '_e94058f2', '_pub-e94058f2', '_pub-3c25d522') }, children)));
};
exports.Fieldset = Fieldset;
//# sourceMappingURL=Fieldset.js.map